/**
 * @file Credit Graph
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Credit Graph component
 */
const vCreditGraph = () => {
	const creditGraphs = document.querySelectorAll( '.v-credit-graph--js' );

	if ( ! creditGraphs.length ) {
		return;
	}

	gsap.registerPlugin( ScrollTrigger );

	[ ...creditGraphs ].forEach( ( graph ) => {
		const min           = parseInt( graph.dataset.min );
		const max           = parseInt( graph.dataset.max );
		const mask          = graph.querySelector( '.v-credit-graph__mask' );
		const number        = graph.querySelector( '.v-credit-graph__number' );
		const graphComplete = new CustomEvent( 'vcreditgraphcomplete', {
			bubbles: true,
			detail:  {
				graph,
			},
		} );
		const graphReverse  = new CustomEvent( 'vcreditgraphreverse', {
			bubbles: true,
			detail:  {
				graph,
			},
		} );

		/**
		 * Used to notify necessary ancestors
		 * of animation fwd completion
		 */
		const graphFwdCb = () => {
			graph.dispatchEvent( graphComplete );
		};

		/**
		 * Used to notify necessary ancestors
		 * of animation reverse completion
		 */
		const graphRwdCb = () => {
			graph.dispatchEvent( graphReverse );
		};

		const targetNumber = parseInt( number.dataset.high );
		const angle        = ( targetNumber - min ) / ( max - min ) * 360;

		const animation = gsap.timeline( {
			defaults: {
				ease:     'sine.out',
				duration: 1,
			},
			scrollTrigger: {
				trigger: graph,
				start:   'bottom bottom',
				onEnter: () => {
					setTimeout( () => animation.timeScale( 1 ), 0 );
					animation.remove( graphRwdCb ).call( graphFwdCb );
				},
				onLeaveBack: () => {
					setTimeout( () => animation.timeScale( -2 ), 0 );
					animation.remove( graphFwdCb ).call( graphRwdCb );
				},
			},
		} )
			.to( mask, {
				'--circle-progress': `${ angle }deg`,
			} )
			.to( number, {
				textContent: targetNumber,
				snap:        { textContent: 1 },
			}, '<' );
	} );
};

export default vCreditGraph;
